import script from "./upload.vue?vue&type=script&setup=true&lang=js"
export * from "./upload.vue?vue&type=script&setup=true&lang=js"

import "./upload.vue?vue&type=style&index=0&id=8e84cece&lang=less"
import "./upload.vue?vue&type=style&index=1&id=8e84cece&scoped=true&lang=less"

import exportComponent from "D:\\code\\saicDesign_frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8e84cece"]])

export default __exports__